import { forkJoin } from 'rxjs';
import { TextBlock, TextBlockData } from 'toolbandi-ui-lib';
import { CrudService, Page, Search, MessageService } from 'elbuild-ui-lib-core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-additional-sections',
	templateUrl: './additional-sections.component.html',
	styleUrls: ['./additional-sections.component.scss']
})
export class AdditionalSectionsComponent implements OnInit {

	@Input()
	entity: string;

	@Input()
	tenderid: number;

	@Input()
	eid: number;

	sections: TextBlockData[];
	loading: boolean;
	textblocks: any[];
	textblocksdata: TextBlockData[];

	constructor(private textblockservice: CrudService<TextBlock>,
		private textblockdataservice: CrudService<TextBlockData>,
		private messageService: MessageService) { }

	ngOnInit() {
		this.load();
	}


	load() {
		this.loading = true;
		if (this.entity && this.tenderid) {
			const adv = new Search('textblock');

			adv.addSimpleFilter('tenderid', this.tenderid);
			adv.addSimpleFilter('entity', this.entity);

			adv.setSortField('sort');
			adv.setSortDirection('asc');
			const adv2 = new Search('textblockdata');

			adv2.addSimpleFilter('entity', this.entity);
			adv2.addSimpleFilter('eid', this.eid);



			const textblocksreq = this.textblockservice.searchEntities(TextBlock, 'textblock', adv, new Page(100));
			const textblockdatareq = this.textblockdataservice.searchEntities(TextBlockData, 'textblockdata', adv2, new Page(100));


			forkJoin([textblocksreq, textblockdatareq]).subscribe((data: any[]) => {

				this.textblocks = data[0];
				this.textblocksdata = data[1];

				this.setupSections();
				this.loading = false;

			}, error => {
				this.messageService.sendError(error);
				this.loading = false;
			});
		}
	}


	setupSections() {
		if (this.textblocks?.length) {
			this.sections = [];
			this.textblocks.forEach((textblock: TextBlock) => {

				const data: TextBlockData = this.textblocksdata.find((t: TextBlockData) => t.textblockid === textblock.id);

				if (data) {
					data.title = textblock.name;
					data.mandatory = textblock.mandatory;
					this.sections.push(data);
				} else {
					this.sections.push(new TextBlockData(textblock.id, this.tenderid, this.entity, this.eid, textblock.name, textblock.mandatory));

				}
			});
		}



	}

	trackByIndex(index: number, obj: any): any {
		return index;
	}

	submit() {
		this.textblockdataservice.saveAll(TextBlockData, 'textblockdata', this.sections).subscribe((data: TextBlockData[]) => {
			this.textblocksdata = data;
			this.setupSections();
			this.messageService.sendSuccess('Sezioni aggiornate', 'Sezioni aggiuntive');


		}, error => {
			this.messageService.sendError(error);
		});
	}


}
